document.addEventListener('DOMContentLoaded', function () {
  /* Nav mobile */
  var toggle = document.querySelector('.nav-toggle');
  var nav = document.querySelector('.site-nav');
  var header = document.querySelector('.site-header');
  if (toggle && nav) {
    function setNav(open) {
      nav.classList.toggle('is-open', open);
      if (header) header.classList.toggle('nav-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.setAttribute('aria-label', open ? 'Fermer le menu' : 'Ouvrir le menu');
    }
    toggle.addEventListener('click', function () {
      setNav(!nav.classList.contains('is-open'));
    });
    /* Fermer le panneau quand on clique un lien du menu */
    nav.addEventListener('click', function (e) {
      if (e.target.closest('a')) setNav(false);
    });
    /* Fermer avec Échap */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') setNav(false);
    });
  }

  /* Root-divider draw-on-scroll */
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var dividers = document.querySelectorAll('.root-divider');
  if ('IntersectionObserver' in window && !reduceMotion) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.4 });
    dividers.forEach(function (el) { io.observe(el); });
  } else {
    dividers.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* Simple gallery lightbox */
  var galleryItems = document.querySelectorAll('[data-lightbox-src]');
  if (galleryItems.length) {
    var overlay = document.createElement('div');
    overlay.className = 'lightbox-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.style.cssText = 'position:fixed;inset:0;background:rgba(20,18,15,.92);display:none;align-items:center;justify-content:center;z-index:200;padding:24px;';
    var img = document.createElement('img');
    img.style.cssText = 'max-width:90vw;max-height:88vh;border:1.5px solid #EFE7D6;';
    var closeBtn = document.createElement('button');
    closeBtn.className = 'lightbox-close';
    closeBtn.setAttribute('aria-label', 'Fermer');
    closeBtn.textContent = '\u2715';
    overlay.appendChild(img);
    overlay.appendChild(closeBtn);
    document.body.appendChild(overlay);

    function close() { overlay.style.display = 'none'; }
    overlay.addEventListener('click', close);
    closeBtn.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    var caption = document.createElement('div');
    caption.className = 'lightbox-caption';
    overlay.appendChild(caption);

    galleryItems.forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        img.src = el.getAttribute('data-lightbox-src');
        img.alt = el.getAttribute('data-lightbox-alt') || '';
        caption.textContent = el.getAttribute('data-lightbox-alt') || '';
        overlay.style.display = 'flex';
      });
    });
  }
});


/* Vignettes de la page produit */
document.addEventListener('click', function (e) {
  var thumb = e.target.closest('.product-thumbs__item');
  if (!thumb) return;
  var main = document.getElementById('ProductMainImage');
  if (main && thumb.getAttribute('data-full')) {
    main.src = thumb.getAttribute('data-full');
  }
});


/* Apparitions au défilement — cible automatiquement les éléments clés */
document.addEventListener('DOMContentLoaded', function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var targets = document.querySelectorAll(
    '.story__text, .story__image, .gallery__item, .artist-card, .review-card, ' +
    '.product-card, .booking-cta__title, .booking-cta__subtitle, .booking-cta__actions, ' +
    '.contact__info, .contact form, .gallery__header, .testimonials__header, ' +
    '.shop-section__header, .artists h2, .artists .eyebrow'
  );
  if (!targets.length) return;

  if (!('IntersectionObserver' in window) || reduceMotion) {
    targets.forEach(function (el) { el.classList.add('reveal', 'is-visible'); });
    return;
  }

  /* Délai échelonné pour les éléments d'une même grille */
  var staggerGroups = ['.gallery__grid', '.artists__grid', '.testimonials__grid', '.product-grid'];
  staggerGroups.forEach(function (sel) {
    document.querySelectorAll(sel).forEach(function (grid) {
      Array.prototype.forEach.call(grid.children, function (child, i) {
        child.style.setProperty('--reveal-delay', (Math.min(i, 5) * 0.09) + 's');
      });
    });
  });

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

  targets.forEach(function (el) {
    el.classList.add('reveal');
    io.observe(el);
  });
});
